import { useReveal } from "../hooks/useReveal";
import { PROCESS_STEPS } from "../data/reels";

export const ProcessSection = () => {
  const ref = useReveal();
  return (
    <section className="relative py-16 sm:py-24 px-5">
      <div ref={ref} className="reveal max-w-5xl mx-auto">
        <h3 className="display text-[36px] sm:text-[56px] lg:text-[72px] leading-[0.95] mb-3">
          <span className="mono text-[color:var(--mr-muted)] text-lg sm:text-2xl align-top mr-2">[</span>
          Let's work together
          <span className="mono text-[color:var(--mr-muted)] text-lg sm:text-2xl align-top ml-2">]</span>
        </h3>
        <p className="text-sm sm:text-base text-[color:var(--mr-muted)] max-w-xl mb-14 sm:mb-20">
          En 4 pasos sencillos, ya estaremos creando juntos para llevar tu marca al siguiente nivel.
        </p>

        <div className="relative">
          {/* Curved path — desktop only */}
          <svg
            className="hidden sm:block absolute inset-0 w-full h-full pointer-events-none"
            viewBox="0 0 800 520"
            preserveAspectRatio="none"
          >
            <path
              d="M 80 60 Q 400 60 400 160 Q 400 260 200 260 Q 0 260 0 360 Q 0 460 400 460 Q 720 460 720 460"
              stroke="var(--mr-purple)"
              strokeWidth="2"
              strokeDasharray="6 6"
              fill="none"
            />
          </svg>

          {/* Steps */}
          <ol className="relative grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-x-10 sm:gap-y-14">
            {PROCESS_STEPS.map((s, i) => (
              <li
                key={s.n}
                data-testid={`step-${s.n}`}
                className={`relative flex gap-4 ${i % 2 === 1 ? "sm:mt-10" : ""}`}
              >
                <div className="shrink-0 w-11 h-11 rounded-full bg-[color:var(--mr-purple)] text-white flex items-center justify-center display text-lg shadow-[0_12px_24px_-8px_rgba(64,20,204,0.55)]">
                  {s.n}
                </div>
                <div className="flex-1">
                  <h4 className="display uppercase text-[18px] sm:text-[22px] mb-2 tracking-wide">
                    {s.title}
                  </h4>
                  <p className="text-sm sm:text-base text-[color:var(--mr-muted)] leading-relaxed">
                    {s.desc}
                  </p>
                  {s.bullets && (
                    <ul className="mt-3 space-y-1.5">
                      {s.bullets.map((b, bi) => (
                        <li
                          key={bi}
                          data-testid={`step-${s.n}-bullet-${bi}`}
                          className="flex items-start gap-2 text-sm sm:text-[15px] text-[color:var(--mr-ink-soft)]"
                        >
                          <span className="mt-0.5 shrink-0 w-4 h-4 rounded-full bg-[color:var(--mr-purple)] text-white flex items-center justify-center text-[10px] font-bold">
                            ✓
                          </span>
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
